import type { ReactNode } from "react";
import { X } from "lucide-react";
import { F, T } from "../../theme/tokens";

// ── Dialog ────────────────────────────────────────────────────────────────────
// A plain centred dialog, for the things that used to be a browser prompt() or
// alert(): those cannot mask a password, cannot be copied from reliably, and
// cannot validate what was typed.

export function Dialog({ title, onClose, children, width = 420 }: { title: string; onClose: () => void; children: ReactNode; width?: number }) {
  return (
    <div
      onClick={onClose}
      style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.45)", zIndex: 1100, display: "flex", alignItems: "center", justifyContent: "center", padding: "16px" }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label={title}
        onClick={(e) => e.stopPropagation()}
        style={{ background: T.surface, border: `1px solid ${T.border}`, borderRadius: "16px", padding: "28px", width: `${width}px`, maxWidth: "100%", maxHeight: "90dvh", overflowY: "auto", fontFamily: F }}
      >
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "18px" }}>
          <h3 style={{ fontSize: "16px", fontWeight: 700, color: T.text, margin: 0 }}>{title}</h3>
          <button onClick={onClose} aria-label="Close" style={{ background: "none", border: "none", cursor: "pointer", color: T.muted, padding: "4px" }}>
            <X size={16} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}

export const dialogInput = {
  width: "100%",
  border: `1px solid ${T.border}`,
  borderRadius: "8px",
  padding: "9px 12px",
  fontSize: "13px",
  fontFamily: F,
  outline: "none",
  color: T.text,
  background: T.surface,
  boxSizing: "border-box" as const,
};

export function FieldLabel({ children }: { children: ReactNode }) {
  return (
    <p style={{ fontSize: "11px", color: T.muted, fontFamily: F, margin: "0 0 5px", textTransform: "uppercase", letterSpacing: "0.06em" }}>{children}</p>
  );
}
